import { SimpleListing } from '@th/shared/src/types/SimpleListing';

export default function navToListing(listing: SimpleListing): void {
  // TODO: if on the map, select it and show it in the airbnb-style sidebar
  // for now though, just nav to the listing details in a new tab
  window.open(`/l/${listing.id}`, '_blank', 'noopener,noreferrer');
}
